import { render, staticRenderFns } from "./xq.vue?vue&type=template&id=3de56042&scoped=true"
import script from "./xq.vue?vue&type=script&lang=js"
export * from "./xq.vue?vue&type=script&lang=js"
import style0 from "./xq.vue?vue&type=style&index=0&id=3de56042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de56042",
  null
  
)

export default component.exports